import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Eye, Award, Clock, Users, Globe } from 'lucide-react';
const values = [{
  icon: Shield,
  title: '安全保障',
  subtitle: 'Safety First',
  desc: 'All companions are thoroughly verified. Your safety and privacy are our top priority.'
}, {
  icon: Eye,
  title: '绝对隐私',
  subtitle: 'Total Discretion',
  desc: 'We guarantee complete confidentiality. No data sharing, no traces, absolute privacy.'
}, {
  icon: Award,
  title: '品质保证',
  subtitle: 'Premium Quality',
  desc: 'Only the finest companions make it to our platform. We maintain the highest standards.'
}, {
  icon: Clock,
  title: '全天候服务',
  subtitle: '24/7 Availability',
  desc: 'Our concierge team is available around the clock to assist with bookings and inquiries.'
}];
export function AboutSection() {
  return <section id="about" className="py-28 bg-[#0a0a0a] relative overflow-hidden" data-id="element-11">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#c9a96e]/5 rounded-full blur-[150px]" data-id="element-12" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#c9a96e]/5 rounded-full blur-[120px]" data-id="element-13" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-14">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-15">
          <span className="inline-block py-1 px-3 rounded-full border border-[#c9a96e]/30 bg-[#c9a96e]/10 text-[#c9a96e] text-xs uppercase tracking-[0.2em] mb-4" data-id="element-16">
            About Us
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-white mb-4" data-id="element-17">
            关于 <span className="text-[#c9a96e]" data-id="element-18">新加坡后宫网</span>
          </h2>
          <div className="w-24 h-1 bg-[#c9a96e] mx-auto rounded-full opacity-50 mb-8" data-id="element-19" />
          <p className="text-neutral-400 max-w-3xl mx-auto text-lg leading-relaxed" data-id="element-20">
            SGHarem（新加坡后宫网）是新加坡首屈一指的高端伴游与按摩服务平台，致力于为尊贵的绅士们提供最优质、最私密的社交体验。
          </p>
        </motion.div>

        {/* Main Content - Two Column */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-24" data-id="element-21">
          {/* Left - Story */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-22">
            <h3 className="text-2xl font-serif text-white mb-6" data-id="element-23">
              新加坡顶级伴游平台
              <span className="block text-[#c9a96e] text-lg mt-1" data-id="element-24">
                Singapore's Finest Companion Platform
              </span>
            </h3>
            <div className="space-y-4 text-neutral-400 leading-relaxed" data-id="element-25">
              <p data-id="element-26">
                自创立以来，SGHarem
                始终秉承"品质至上、隐私第一"的理念，精心筛选每一位入驻佳丽，确保为客户提供无与伦比的陪伴体验。
              </p>
              <p data-id="element-27">
                我们的佳丽来自世界各地，不仅容貌出众，更兼具良好的教育背景与社交素养。无论是商务宴请、私人派对，还是城市探索，她们都能成为您最得体、最迷人的伴侣。
              </p>
              <p data-id="element-28">
                SGHarem
                覆盖新加坡全岛，从繁华的乌节路到迷人的滨海湾，从悠闲的圣淘沙到热闹的克拉码头，随时随地为您安排完美邂逅。
              </p>
              <p className="text-[#c9a96e]/80 italic border-l-2 border-[#c9a96e]/30 pl-4" data-id="element-29">
                "我们不仅仅是一个平台，更是一种生活方式的象征。SGHarem
                代表着品味、优雅与极致的私人体验。"
              </p>
            </div>
          </motion.div>

          {/* Right - Stats & Highlights */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col justify-center" data-id="element-30">
            <div className="grid grid-cols-2 gap-6" data-id="element-31">
              {[{
              value: '150+',
              label: '精选佳丽',
              sublabel: 'Verified Companions'
            }, {
              value: '6+',
              label: '覆盖区域',
              sublabel: 'Areas Covered'
            }, {
              value: '4.9',
              label: '客户评分',
              sublabel: 'Client Rating'
            }, {
              value: '24/7',
              label: '全天服务',
              sublabel: 'Always Available'
            }].map((stat, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="bg-[#111111] border border-neutral-800 rounded-xl p-6 text-center hover:border-[#c9a96e]/30 transition-colors" data-id="element-32">
                  <span className="text-3xl md:text-4xl font-serif font-bold text-[#c9a96e]" data-id="element-33">
                    {stat.value}
                  </span>
                  <p className="text-white text-sm mt-2 font-medium" data-id="element-34">
                    {stat.label}
                  </p>
                  <p className="text-neutral-500 text-xs mt-1" data-id="element-35">
                    {stat.sublabel}
                  </p>
                </motion.div>)}
            </div>

            <div className="mt-8 p-6 bg-[#111111] border border-[#c9a96e]/20 rounded-xl" data-id="element-36">
              <div className="flex items-center gap-3 mb-3" data-id="element-37">
                <Globe size={20} className="text-[#c9a96e]" data-id="element-38" />
                <h4 className="text-white font-serif" data-id="element-39">
                  服务覆盖 Service Areas
                </h4>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-40">
                {['乌节路 Orchard', '滨海湾 Marina Bay', '圣淘沙 Sentosa', '克拉码头 Clarke Quay', '武吉士 Bugis', '丹戎巴葛 Tanjong Pagar'].map(area => <span key={area} className="px-3 py-1 bg-[#0a0a0a] border border-neutral-800 rounded-full text-neutral-400 text-xs" data-id="element-41">
                    {area}
                  </span>)}
              </div>
            </div>
          </motion.div>
        </div>

        {/* Core Values */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-42">
          <h3 className="text-2xl md:text-3xl font-serif text-white mb-2" data-id="element-43">
            我们的承诺 <span className="text-[#c9a96e]" data-id="element-44">Our Promise</span>
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-45">
          {values.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111111] border border-neutral-800 rounded-xl p-6 text-center group hover:border-[#c9a96e]/30 transition-all duration-500" data-id="element-46">
              <div className="w-14 h-14 rounded-full bg-[#0a0a0a] border border-[#c9a96e]/20 flex items-center justify-center mx-auto mb-5 group-hover:border-[#c9a96e]/50 group-hover:shadow-[0_0_15px_rgba(201,169,110,0.15)] transition-all duration-500" data-id="element-47">
                <item.icon className="text-[#c9a96e]" size={24} data-id="element-48" />
              </div>
              <h4 className="text-white font-serif text-lg mb-1" data-id="element-49">
                {item.title}
              </h4>
              <p className="text-[#c9a96e] text-xs uppercase tracking-wider mb-3" data-id="element-50">
                {item.subtitle}
              </p>
              <p className="text-neutral-500 text-sm leading-relaxed" data-id="element-51">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}